import AuthRight from "../../components/auth/AuthRight";
import AuthTitle from "../../components/auth/AuthTitle";
import LoginForm from "../../components/auth/LoginForm";

function Login() {
  return (
    <div className="flex h-full">
      <div className="flex w-1/2 flex-col items-center justify-center bg-[#E7F5FF]">
        <AuthTitle />
        <LoginForm />
      </div>
      <AuthRight
        title="Welcome Back to MyWorkApp!"
        subTitle="Please login to your account to access all of your information."
      />
    </div>
  );
}

export default Login;
